export const physicalLibraryCopy = {
  "tr": {
    "name": "Dergâh Kütüphanesi",
    "intro": "Dergâhtaki fiziki kitaplar. Kitabı bulun; oda, dolap ve raf konumunu görün.",
    "search": "Kitap, müellif, demirbaş veya raf ara…",
    "find": "Ara",
    "loading": "Yükleniyor…",
    "total": "Toplam nüsha",
    "add": "Kitap / nüsha kaydet",
    "edit": "Konumu ve durumu düzenle",
    "existing": "Mevcut eser / baskı",
    "newWork": "Yeni eser veya farklı baskı",
    "title": "Kitap adı",
    "author": "Müellif",
    "edition": "Baskı / yayınevi / yıl",
    "volume": "Cilt",
    "isbn": "ISBN",
    "subject": "Konu",
    "barcode": "Demirbaş / barkod",
    "room": "Oda / bölüm",
    "cabinet": "Dolap",
    "shelf": "Raf",
    "position": "Raftaki sıra",
    "status": "Durum",
    "available": "Rafta",
    "on_loan": "Ödünçte",
    "repair": "Bakımda",
    "missing": "Bulunamıyor",
    "notes": "Not",
    "codeHint": "Demirbaş benzersiz olmalı; örnek: DKG-000001. Aynı baskının ikinci nüshası için mevcut eseri seçin.",
    "save": "Kaydet",
    "cancel": "Vazgeç",
    "empty": "Henüz fiziki kitap kaydı yok.",
    "noResults": "Aramanıza uygun kitap bulunamadı.",
    "duplicate": "Bu demirbaş numarası zaten kayıtlı.",
    "changed": "Kayıt başka bir işlemle değişti. Listeyi yenileyip tekrar düzenleyin.",
    "error": "İşlem tamamlanamadı. Yeniden deneyin.",
    "previous": "Önceki",
    "next": "Sonraki",
    "digital": "Dijital Kütüphane",
    "cta": "Raf Kataloğunu Aç",
    "physicalBooks": "Fiziki kitaplar",
    "shelfLabel": "Dolap ve raf"
  },
  "en": {
    "name": "Dergâh Library",
    "intro": "Find physical books in the dergâh by room, cabinet and shelf.",
    "search": "Search book, author, inventory number or shelf…",
    "find": "Search",
    "loading": "Loading…",
    "total": "Total copies",
    "add": "Register book / copy",
    "edit": "Edit location and status",
    "existing": "Existing work / edition",
    "newWork": "New work or different edition",
    "title": "Book title",
    "author": "Author",
    "edition": "Edition / publisher / year",
    "volume": "Volume",
    "isbn": "ISBN",
    "subject": "Subject",
    "barcode": "Inventory / barcode",
    "room": "Room / section",
    "cabinet": "Cabinet",
    "shelf": "Shelf",
    "position": "Shelf position",
    "status": "Status",
    "available": "On shelf",
    "on_loan": "On loan",
    "repair": "Under repair",
    "missing": "Missing",
    "notes": "Note",
    "codeHint": "Use a unique inventory number, e.g. DKG-000001. Select the existing edition for another copy.",
    "save": "Save",
    "cancel": "Cancel",
    "empty": "No physical books registered yet.",
    "noResults": "No matching books.",
    "duplicate": "Inventory number already exists.",
    "changed": "Record changed. Reload and edit again.",
    "error": "Could not complete. Please retry.",
    "previous": "Previous",
    "next": "Next",
    "digital": "Digital Library",
    "cta": "Open Shelf Catalogue",
    "physicalBooks": "Physical books",
    "shelfLabel": "Cabinet and shelf"
  },
  "fa": {
    "name": "کتابخانه درگاه",
    "intro": "کتاب‌های فیزیکی درگاه را با اتاق، کمد و قفسه پیدا کنید.",
    "search": "جستجوی کتاب، نویسنده، شماره ثبت یا قفسه…",
    "find": "جستجو",
    "loading": "در حال بارگذاری…",
    "total": "تعداد نسخه‌ها",
    "add": "ثبت کتاب / نسخه",
    "edit": "ویرایش مکان و وضعیت",
    "existing": "اثر / چاپ موجود",
    "newWork": "اثر تازه یا چاپ متفاوت",
    "title": "نام کتاب",
    "author": "نویسنده",
    "edition": "چاپ / ناشر / سال",
    "volume": "جلد",
    "isbn": "ISBN",
    "subject": "موضوع",
    "barcode": "شماره ثبت / بارکد",
    "room": "اتاق / بخش",
    "cabinet": "کمد",
    "shelf": "قفسه",
    "position": "جایگاه در قفسه",
    "status": "وضعیت",
    "available": "در قفسه",
    "on_loan": "امانت داده شده",
    "repair": "در تعمیر",
    "missing": "پیدا نمی‌شود",
    "notes": "یادداشت",
    "codeHint": "شماره ثبت یکتا باشد؛ نمونه DKG-000001. برای نسخه دوم همان چاپ، اثر موجود را انتخاب کنید.",
    "save": "ذخیره",
    "cancel": "انصراف",
    "empty": "هنوز کتاب فیزیکی ثبت نشده است.",
    "noResults": "کتاب مطابق یافت نشد.",
    "duplicate": "شماره ثبت موجود است.",
    "changed": "رکورد تغییر کرده؛ فهرست را تازه و دوباره ویرایش کنید.",
    "error": "عملیات انجام نشد؛ دوباره تلاش کنید.",
    "previous": "قبلی",
    "next": "بعدی",
    "digital": "کتابخانه دیجیتال",
    "cta": "باز کردن فهرست قفسه‌ها",
    "physicalBooks": "کتاب‌های فیزیکی",
    "shelfLabel": "کمد و قفسه"
  },
  "ar": {
    "name": "مكتبة الدرجاه",
    "intro": "ابحث عن الكتب الورقية حسب الغرفة والخزانة والرف.",
    "search": "ابحث عن كتاب أو مؤلف أو رقم جرد أو رف…",
    "find": "بحث",
    "loading": "جار التحميل…",
    "total": "مجموع النسخ",
    "add": "تسجيل كتاب / نسخة",
    "edit": "تعديل الموقع والحالة",
    "existing": "عمل / طبعة موجودة",
    "newWork": "عمل جديد أو طبعة مختلفة",
    "title": "عنوان الكتاب",
    "author": "المؤلف",
    "edition": "الطبعة / الناشر / السنة",
    "volume": "المجلد",
    "isbn": "ISBN",
    "subject": "الموضوع",
    "barcode": "رقم الجرد / الباركود",
    "room": "الغرفة / القسم",
    "cabinet": "الخزانة",
    "shelf": "الرف",
    "position": "الموضع على الرف",
    "status": "الحالة",
    "available": "على الرف",
    "on_loan": "معار",
    "repair": "قيد الإصلاح",
    "missing": "مفقود",
    "notes": "ملاحظة",
    "codeHint": "رقم جرد فريد، مثل DKG-000001. اختر الطبعة الموجودة لنسخة إضافية.",
    "save": "حفظ",
    "cancel": "إلغاء",
    "empty": "لم تسجل كتب ورقية بعد.",
    "noResults": "لا توجد كتب مطابقة.",
    "duplicate": "رقم الجرد موجود بالفعل.",
    "changed": "تغير السجل؛ حدّث القائمة وعدّل مجدداً.",
    "error": "تعذر إكمال العملية؛ حاول مجدداً.",
    "previous": "السابق",
    "next": "التالي",
    "digital": "المكتبة الرقمية",
    "cta": "فتح فهرس الرفوف",
    "physicalBooks": "كتب ورقية",
    "shelfLabel": "الخزانة والرف"
  },
  "de": {
    "name": "Dergâh-Bibliothek",
    "intro": "Physische Bücher nach Raum, Schrank und Regal finden.",
    "search": "Buch, Autor, Inventarnummer oder Regal suchen…",
    "find": "Suchen",
    "loading": "Wird geladen…",
    "total": "Exemplare insgesamt",
    "add": "Buch / Exemplar erfassen",
    "edit": "Standort und Status ändern",
    "existing": "Vorhandenes Werk / Ausgabe",
    "newWork": "Neues Werk oder andere Ausgabe",
    "title": "Buchtitel",
    "author": "Autor",
    "edition": "Ausgabe / Verlag / Jahr",
    "volume": "Band",
    "isbn": "ISBN",
    "subject": "Thema",
    "barcode": "Inventarnummer / Barcode",
    "room": "Raum / Bereich",
    "cabinet": "Schrank",
    "shelf": "Regal",
    "position": "Position im Regal",
    "status": "Status",
    "available": "Im Regal",
    "on_loan": "Ausgeliehen",
    "repair": "In Reparatur",
    "missing": "Vermisst",
    "notes": "Notiz",
    "codeHint": "Eindeutige Inventarnummer, z. B. DKG-000001. Für weitere Exemplare die vorhandene Ausgabe wählen.",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "empty": "Noch keine physischen Bücher erfasst.",
    "noResults": "Keine passenden Bücher.",
    "duplicate": "Inventarnummer bereits vorhanden.",
    "changed": "Datensatz geändert. Neu laden und erneut bearbeiten.",
    "error": "Vorgang fehlgeschlagen. Erneut versuchen.",
    "previous": "Zurück",
    "next": "Weiter",
    "digital": "Digitale Bibliothek",
    "cta": "Regalkatalog öffnen",
    "physicalBooks": "Physische Bücher",
    "shelfLabel": "Schrank und Regal"
  },
  "fr": {
    "name": "Bibliothèque du Dergâh",
    "intro": "Trouvez les livres physiques par salle, armoire et rayon.",
    "search": "Rechercher livre, auteur, numéro ou rayon…",
    "find": "Rechercher",
    "loading": "Chargement…",
    "total": "Total des exemplaires",
    "add": "Enregistrer livre / exemplaire",
    "edit": "Modifier emplacement et état",
    "existing": "Œuvre / édition existante",
    "newWork": "Nouvelle œuvre ou autre édition",
    "title": "Titre du livre",
    "author": "Auteur",
    "edition": "Édition / éditeur / année",
    "volume": "Tome",
    "isbn": "ISBN",
    "subject": "Sujet",
    "barcode": "Inventaire / code-barres",
    "room": "Salle / section",
    "cabinet": "Armoire",
    "shelf": "Rayon",
    "position": "Position sur le rayon",
    "status": "État",
    "available": "En rayon",
    "on_loan": "Prêté",
    "repair": "En réparation",
    "missing": "Introuvable",
    "notes": "Note",
    "codeHint": "Numéro unique, par ex. DKG-000001. Choisissez l’édition existante pour un autre exemplaire.",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "empty": "Aucun livre physique enregistré.",
    "noResults": "Aucun livre correspondant.",
    "duplicate": "Numéro déjà enregistré.",
    "changed": "Fiche modifiée. Actualisez puis réessayez.",
    "error": "Opération impossible. Réessayez.",
    "previous": "Précédent",
    "next": "Suivant",
    "digital": "Bibliothèque numérique",
    "cta": "Ouvrir le catalogue des rayons",
    "physicalBooks": "Livres physiques",
    "shelfLabel": "Armoire et rayon"
  },
  "es": {
    "name": "Biblioteca del Dergâh",
    "intro": "Busque libros físicos por sala, armario y estante.",
    "search": "Buscar libro, autor, inventario o estante…",
    "find": "Buscar",
    "loading": "Cargando…",
    "total": "Total de ejemplares",
    "add": "Registrar libro / ejemplar",
    "edit": "Editar ubicación y estado",
    "existing": "Obra / edición existente",
    "newWork": "Obra nueva u otra edición",
    "title": "Título del libro",
    "author": "Autor",
    "edition": "Edición / editorial / año",
    "volume": "Tomo",
    "isbn": "ISBN",
    "subject": "Tema",
    "barcode": "Inventario / código de barras",
    "room": "Sala / sección",
    "cabinet": "Armario",
    "shelf": "Estante",
    "position": "Posición en estante",
    "status": "Estado",
    "available": "En estante",
    "on_loan": "Prestado",
    "repair": "En reparación",
    "missing": "No localizado",
    "notes": "Nota",
    "codeHint": "Número único, como DKG-000001. Seleccione la edición existente para otra copia.",
    "save": "Guardar",
    "cancel": "Cancelar",
    "empty": "No hay libros físicos registrados.",
    "noResults": "No hay libros coincidentes.",
    "duplicate": "El número ya existe.",
    "changed": "Registro cambiado. Actualice y edite de nuevo.",
    "error": "No se pudo completar. Reintente.",
    "previous": "Anterior",
    "next": "Siguiente",
    "digital": "Biblioteca digital",
    "cta": "Abrir catálogo de estantes",
    "physicalBooks": "Libros físicos",
    "shelfLabel": "Armario y estante"
  },
  "ru": {
    "name": "Библиотека дергаха",
    "intro": "Найдите печатные книги по комнате, шкафу и полке.",
    "search": "Поиск книги, автора, номера или полки…",
    "find": "Поиск",
    "loading": "Загрузка…",
    "total": "Всего экземпляров",
    "add": "Добавить книгу / экземпляр",
    "edit": "Изменить место и состояние",
    "existing": "Имеющееся произведение / издание",
    "newWork": "Новое произведение или другое издание",
    "title": "Название книги",
    "author": "Автор",
    "edition": "Издание / издатель / год",
    "volume": "Том",
    "isbn": "ISBN",
    "subject": "Тема",
    "barcode": "Инвентарный номер / штрихкод",
    "room": "Комната / отдел",
    "cabinet": "Шкаф",
    "shelf": "Полка",
    "position": "Место на полке",
    "status": "Состояние",
    "available": "На полке",
    "on_loan": "Выдана",
    "repair": "В ремонте",
    "missing": "Не найдена",
    "notes": "Примечание",
    "codeHint": "Уникальный номер, например DKG-000001. Для другого экземпляра выберите имеющееся издание.",
    "save": "Сохранить",
    "cancel": "Отмена",
    "empty": "Печатные книги ещё не добавлены.",
    "noResults": "Книги не найдены.",
    "duplicate": "Номер уже существует.",
    "changed": "Запись изменилась. Обновите и повторите.",
    "error": "Не удалось завершить. Повторите.",
    "previous": "Назад",
    "next": "Далее",
    "digital": "Цифровая библиотека",
    "cta": "Открыть каталог полок",
    "physicalBooks": "Печатные книги",
    "shelfLabel": "Шкаф и полка"
  },
  "zh": {
    "name": "道堂图书馆",
    "intro": "按房间、书柜和书架查找道堂的纸质书。",
    "search": "搜索书名、作者、登记号或书架…",
    "find": "搜索",
    "loading": "加载中…",
    "total": "册数总计",
    "add": "登记书籍 / 副本",
    "edit": "编辑位置和状态",
    "existing": "已有作品 / 版本",
    "newWork": "新作品或不同版本",
    "title": "书名",
    "author": "作者",
    "edition": "版本 / 出版社 / 年份",
    "volume": "卷",
    "isbn": "ISBN",
    "subject": "主题",
    "barcode": "登记号 / 条码",
    "room": "房间 / 分区",
    "cabinet": "书柜",
    "shelf": "书架",
    "position": "架上位置",
    "status": "状态",
    "available": "在架",
    "on_loan": "借出",
    "repair": "维修中",
    "missing": "未找到",
    "notes": "备注",
    "codeHint": "登记号必须唯一，例如 DKG-000001。同一版本的另一副本请选择已有版本。",
    "save": "保存",
    "cancel": "取消",
    "empty": "尚未登记纸质书。",
    "noResults": "没有匹配书籍。",
    "duplicate": "登记号已存在。",
    "changed": "记录已更改，请刷新后重新编辑。",
    "error": "操作未完成，请重试。",
    "previous": "上一页",
    "next": "下一页",
    "digital": "数字图书馆",
    "cta": "打开书架目录",
    "physicalBooks": "纸质书",
    "shelfLabel": "书柜和书架"
  }
};
